module.exports = __webpack_public_path__ + "static/media/c9bannerModul2_small.76c0b499.jpg";